export {};

setTimeout(() => {
  window.location.reload();
}, 86_400_000);
